export default "__VITE_ASSET__lev1yHF1__"